import { render, staticRenderFns } from "./comp_CategoriesMenu.vue?vue&type=template&id=77414f14&scoped=true&"
import script from "./comp_CategoriesMenu.vue?vue&type=script&lang=js&"
export * from "./comp_CategoriesMenu.vue?vue&type=script&lang=js&"
import style0 from "./comp_CategoriesMenu.vue?vue&type=style&index=0&id=77414f14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77414f14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
